import { render, staticRenderFns } from "./CopyEvent.vue?vue&type=template&id=5eee0341&"
import script from "./CopyEvent.vue?vue&type=script&lang=js&"
export * from "./CopyEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports